import { render } from "./pieChart2.vue?vue&type=template&id=66647438"
import script from "./pieChart2.vue?vue&type=script&lang=js"
export * from "./pieChart2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__